import Vue from 'vue';
import app from 'app';
import _ from 'lodash-extended';
import $ from 'jquery';
import moment from 'moment';

Vue.mixin({
  methods: {
    /** Prepend urls with protocol supporting fallback urls */
    mixinSrc(...args) {
      if (_.isPlainObject(args[0])) {
        const obj = args[0];
        // refer to args as props of object
        for (let n = 1, N = args.length; n < N; n++) {
          if (!_.isEmpty(obj[args[n]])) {
            return app.prependHttp(String(obj[args[n]]));
          }
        }
      } else {
        // refer to args as "fallbackable" url strings
        for (let n = 0, N = args.length; n < N; n++) {
          if (!_.isEmpty(args[n])) {
            return app.prependHttp(String(args[n]));
          }
        }
      }

      return '';
    },

    mixinProxySrc(...args) {
      const url = this.mixinSrc(...args);
      if (app.isWochitUrl(url)) {
        return url;
      } else {
        return `${
          serverProfile.proxyApiUrl
        }/api/v1/proxy?url=${encodeURIComponent(url)}`;
      }
    },

    mixinShowViewInModal(options) {
      return app.showModal(options);
    },

    isRestricted: function (asset) {
      asset = asset.attributes || asset;
      return (
        !_.isEmpty(asset.metadata.restrictions) || asset.metadata.expirationDate
      );
    },

    isEditorial: function (asset) {
      asset = asset.attributes || asset;
      return app.assetType.isEditorial(asset);
    },

    isDynamic: function (asset) {
      asset = asset.attributes || asset;
      return app.assetType.isDynamicProvider(asset);
    },

    isContainsRestrictions: function (asset) {
      asset = asset.attributes || asset;
      return asset.isContainsRestrictions;
    },

    isFairUse: function (asset) {
      asset = asset.attributes || asset;
      return app.assetType.isFairUse(asset) && !asset.isContainsRestrictions;
    },

    getDisplayDuration: function (asset) {
      return moment.utc(asset.displayDuration * 1000).format('m:ss');
    },
    printDateTime: function (dateLong) {
      return dateLong ? moment(dateLong).format('MM/DD/YYYY hh:mma') : '';
    },
    $isEditable: function (target) {
      return $(target).isEditable();
    },
  },
});
